import apiCore from '@centit/api-core'
const apiAuth = apiCore.create('admin')

/**
 * 登录
 * @param user
 * @returns {*}
 */
export function login (user = { username: '', password: '' }) {
  return apiAuth.post('login', {
    ...user,
    ajax: true,
  }, { useFormData: true })
}

/**
 * 单点登录
 */
export function loginCas () {
  const ctx = apiCore.baseURL
  const webUrl = encodeURIComponent(window.location.href)
  window.location.href = `${ctx}/admin/system/mainframe/logincas?webUrl=${webUrl}`
}

/**
 * 登出
 * @returns {*}
 */
export function logout () {
  return apiAuth.get('logout')
}

/**
 * 判断是否登录
 * @returns {*}
 */
export function checkLogin () {
  return apiAuth.get('system/mainframe/hasLogin')
}

/**
 * 获取登录用户信息
 * @returns {*}
 */
export function getUserInfo () {
  return apiAuth.get('system/mainframe/currentuser')
}

export function getCSRF () {
  return apiAuth.get('system/mainframe/login/csrf')
}

/**
 * 从本地得到token
 * @returns {string}
 */
export function getLocalToken () {
  return localStorage.getItem('$TOKEN')
}

/**
 * 将token写入本地
 * @param token
 */
export function setLocalToken (token) {
  localStorage.setItem('$TOKEN', token)
}


export function checkPassword(password) {
  return apiAuth.post('/system/mainframe/checkpwd', {
    ...password,
    ajax: true,
  }, { useFormData: true })
}

export function changePassword(user) {
  return apiAuth.put(`/system/mainframe/changepwd`, user, { useFormData: true })
}

/**
 * 获取当前用户岗位信息
 */
export function queryPositions() {
  return apiAuth.get('system/mainframe/userstations')
    .then(data => {
      return data.map(m => {
        return {
          ...m,
          valueField: `${m.userStationText} - ${m.userRankText} - ${m.unitName}`,
        }
      })
    })
}

export function getPosition() {
  return apiAuth.get('system/mainframe/usercurrstation')
}

export function setPosition(id) {
  return apiAuth.put(`/system/mainframe/setuserstation/${id}`)
}
